















import { Component, Vue, Prop } from "vue-property-decorator";
import SVGA from "svgaplayerweb";
@Component
export default class Logout extends Vue {
  @Prop({ default: 0 }) public loadingType;

  public url = "https://mobile-pre.996box.com/img/loading.svga";

  public mounted() {
    this.playSvga(this.url, !this.loadingType ? 1 : 2);
  }

  public playSvga(url, id) {
    setTimeout(() => {
      let svgaBox: any;
      svgaBox = this.$refs["svgaBoxClient" + `${id}`];
      const player: any = new SVGA.Player(svgaBox);
      const parser: any = new SVGA.Parser();
      // 注意，这里必须是服务器地址，否则报错
      parser.load(url, (videoItem) => {
        player.setVideoItem(videoItem);
        player.startAnimation();
      });
    }, 100);
  }
}
